
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConsultaPerfil} from 'src/app/shared/model/security/persona.model';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

const API_URL = environment.apiUrl;

@Injectable()
export class AltaperfilService {

constructor(private router: Router, private http: HttpClient) { }

    ConsultaSitios(): Observable<any> {
      return this.http.get(API_URL + 'controller/getsitios.do', { }); // para el puro sitio
    }
    ConsultaMenus(idSitio: String): Observable<any> {
        return this.http.post(API_URL + 'controller/buscaMenus.do', idSitio, { }); // para los puros menus
      }
    GuardaPerfil(perfil: ConsultaPerfil): Observable<any> {
      return this.http.post(API_URL + 'controller/saveOrUpdatePerfil.do', perfil,  { }); // para Guradar el perfil
        }
    ConsulXUpdatePerfil(pId: Number): Observable<any> {
          return this.http.post<ConsultaPerfil[]>(API_URL + 'controller/buscaPerfil.do', pId, { }); // para los puros menus
        }
    ConsulXUpdateMenu(pId: Number): Observable<any> {
          return this.http.post<ConsultaPerfil[]>(API_URL + 'controller/consultaMenusIdPerfil.do', pId, { }); /// para los puros menus
        }
}
